import { render, staticRenderFns } from "./ScreenProforma.vue?vue&type=template&id=3d6e8744"
import script from "./ScreenProforma.vue?vue&type=script&lang=js"
export * from "./ScreenProforma.vue?vue&type=script&lang=js"
import style0 from "./ScreenProforma.vue?vue&type=style&index=0&id=3d6e8744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports